import React from 'react'
import circle from "../icons/circle.png"
import zig from "../icons/zig-zag.png"
import add from "../icons/add.png"
import icon from "../icons/up-right.png"
import { Link } from 'react-router-dom'

export default function CommonContact() {
  return (
    <div className="bg-transparent relative  flex flex-col items-center mb-20 justify-center gap-10 h-[70vh] bg-gradient-to-r from-[#e341e006] to-[#c750c531]">
    <img src={circle} alt="circle" className="absolute left-40 "></img>{" "}
    <img src={circle} alt="circle" className="absolute left-[90%] top-10 "></img>
    <img src={zig} alt="circle" className="absolute left-[90%] top-3/4"></img>
    <img src={add} alt="circle" className="absolute left-[95%] top-2/4"></img>
    <img src={add} alt="circle" className="absolute left-[10%] top-10 rotate-12"></img>
    <img src={add} alt="circle" className="absolute left-[26%] top-3/4"></img>

    <div className="text-center">
      <h1 className="text-5xl font-medium font-poppins text-[rgba(255,255,255,.5)]">
        Contact us for the service you <br /> want to use
      </h1>
    </div>
    <Link to={"../contact"} className="px-8 py-3 text-2xl font-poppins border-2 items-center justify-center gap-2 rounded-full flex text-[rgba(255,255,255,.5)] outline-[rgba(255,255,255,.5)]">
      Contact us
      <img src={icon} alt="upright-arrow" className="w-6 h-6 " />
    </Link>
  </div>
  )
}
